import { TABLE_LENGTH } from './constants/Generic';

export const createBoard = (tableLength) => {
	const board = [];
	for (let i = 0; i < tableLength; i += 1) {
		board[i] = [];
		for (let j = 0; j < tableLength; j += 1) {
			board[i].push({
				x: i,
				y: j,
				id: i * 10 + j,
				canStepOn: false,
			});
		}
	}
	return board;
};

export const findSteppableFields = (board, steppedOn) => {
	const {
		x, y,
	} = steppedOn;

	const steppableFields = [];

	// TODO remove null and filter, add if statement and push if field is valid, check if it is not clicked also, maybe create some checker function
	if (y - 3 >= 0 && !board[x][y - 3].stepped) {
		steppableFields.push({
			x,
			y: y - 3,
		});
	}

	if (y + 3 < TABLE_LENGTH && !board[x][y + 3].stepped) {
		steppableFields.push({
			x,
			y: y + 3,
		});
	}

	if (x - 3 >= 0 && !board[x - 3][y].stepped) {
		steppableFields.push({
			x: x - 3,
			y,
		});
	}

	if (x + 3 < TABLE_LENGTH && !board[x + 3][y].stepped) {
		steppableFields.push({
			x: x + 3,
			y,
		});
	}

	if (x + 2 < TABLE_LENGTH && y - 2 >= 0 && !board[x + 2][y - 2].stepped) {
		steppableFields.push({
			x: x + 2,
			y: y - 2,
		});
	}

	if (x - 2 >= 0 && y - 2 >= 0 && !board[x - 2][y - 2].stepped) {
		steppableFields.push({
			x: x - 2,
			y: y - 2,
		});
	}

	if (x + 2 < TABLE_LENGTH && y + 2 < TABLE_LENGTH && !board[x + 2][y + 2].stepped) {
		steppableFields.push({
			x: x + 2,
			y: y + 2,
		});
	}

	if (x - 2 >= 0 && y + 2 < TABLE_LENGTH && !board[x - 2][y + 2].stepped) {
		steppableFields.push({
			x: x - 2,
			y: y + 2,
		});
	}

	return steppableFields;
};
